import type { FormEvent } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useUserRepository } from '../user/useUserRepository';
import { SocialAuthShell } from './social-auth-shell';
import { SocialAuthSuccess } from './social-auth-success';
import { useSocialMode } from './social-mode-context';

export function SocialRetrieve() {
  const { recoverPassword } = useUserRepository();
  const { withSocialParam } = useSocialMode();
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [sentEmail, setSentEmail] = useState('');

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const email = new FormData(event.currentTarget).get('email');

    if (typeof email !== 'string' || !email) {
      setError('Escribe tu correo electrónico.');
      return;
    }

    setError('');
    setIsSubmitting(true);

    try {
      const sent = await recoverPassword({ email });

      if (sent) {
        setSentEmail(email);
      } else {
        setError('No hemos podido enviar las instrucciones. Inténtalo de nuevo.');
      }
    } catch {
      setError('No hemos podido enviar las instrucciones. Inténtalo de nuevo.');
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <SocialAuthShell
      claim="Recupera tu acceso."
      description="Te ayudamos a volver a tu cuenta de forma segura."
      footer={sentEmail ? (
        <>
          <p>¿No te ha llegado? <button className="or-social-auth__inline-action" onClick={() => setSentEmail('')} type="button">Reintentar</button></p>
          <p><Link to={withSocialParam('/login')}>Volver a acceso</Link></p>
        </>
      ) : (
        <p>¿Lo recuerdas? <Link to={withSocialParam('/login')}>Iniciar sesión</Link></p>
      )}
      subtitle={sentEmail ? '' : 'Introduce tu correo y te enviaremos instrucciones para crear una nueva.'}
      title={sentEmail ? '' : '¿Olvidaste tu contraseña?'}
    >
      {sentEmail ? (
        <SocialAuthSuccess title="Revisa tu correo">
          Si existe una cuenta asociada a <strong>{sentEmail}</strong>, recibirás un enlace para restablecer tu contraseña.
        </SocialAuthSuccess>
      ) : (
        <form className="or-social-auth__form" onSubmit={handleSubmit}>
          <label className="or-social-auth__field">
            <span className="or-social-auth__field-label">Correo electrónico</span>
            <input autoComplete="email" className="or-social-auth__input" inputMode="email" name="email" placeholder="tucorreo@dominio.com" required type="email" />
          </label>
          {error ? <p className="or-social-auth__error" role="alert">{error}</p> : null}
          <button className="or-social-auth__submit" disabled={isSubmitting} type="submit">{isSubmitting ? 'Enviando…' : 'Enviar instrucciones'}</button>
        </form>
      )}
    </SocialAuthShell>
  );
}
